module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "sense-container"
  }, [_c('div', {
    staticClass: "sense-header"
  }, [_c('div', {
    staticClass: "sense-header-box clearfix"
  }, [_c('h1', {
    staticClass: "fl"
  }, [_vm._v("工具")]), _vm._v(" "), _c('div', {
    staticClass: "sense-nav fl"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "mode": "horizontal",
      "background-color": "#001529"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "3"
    }
  }, [_c('router-link', {
    staticClass: "tag-list",
    attrs: {
      "tag": "span",
      "to": "/searchLicense"
    }
  }, [_vm._v("C2D/D2C反查许可")])], 1)], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "sense-content"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "sense-footer"
  }, [_vm._v("\n\t\t北京深盾科技股份有限公司 ©\n\t\t"), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v("京ICP备16009104号")]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802025663"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/img/keep-record.png")
    }
  }), _vm._v("京公网安备 11010802025663号")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0566967c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 558
// module chunks = 1